import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  smData: null,
  permission: null,
  error: null,
  loading: false,
  token: null,

  qchmgGetData: null,
  qchotelGetData: null,
  qcsignStatusData: { signature: null, mydocs: null },
  reportsGetData: null,
  envelopTriggerData: null,
  qcReportsRequestSuccess: null,
  qcsendFailedEnvelopsData: null,
  qcmarkAsCompleteResponseData: null,
  qcEnvGetData: null,
};

const qchmgGetSuccess = (state, action) => {
  return updateObject(state, {
    qchmgGetData: action.data,
    error: null,
    loading: false,
  });
};

const qchotelGetSuccess = (state, action) => {
  return updateObject(state, {
    qchotelGetData: action.data,
    error: null,
    loading: false,
  });
};
const qcReporstRequestGetSuccess = (state, action) => {
  return updateObject(state, {
    qcReportsRequestSuccess: action.data,
    error: null,
    loading: false,
  });
};
const qcenvlptrigrGetSuccess = (state, action) => {
  return updateObject(state, {
    envelopTriggerData: action.data,
    error: null,
    loading: false,
  });
};

const qcEnvironImpactGetSuccess = (state, action) => {
  return updateObject(state, {
    qcEnvGetData: action.data,
    error: null,
    loading: false,
  });
};

const qcApi = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QC_HMG_GET_SUCCESS:
      return qchmgGetSuccess(state, action);
    case actionTypes.QC_HOTEL_GET_SUCCESS:
      return qchotelGetSuccess(state, action);
    case actionTypes.QC_ENVLOP_TRIGR_SUCCESS:
      return qcenvlptrigrGetSuccess(state, action);
    case actionTypes.QC_REPORTS_QC_SUCCESS:
      return qcReporstRequestGetSuccess(state, action);
    case actionTypes.QC_ENVIRON_IMPACT_GET_SUCCESS:
      return qcEnvironImpactGetSuccess(state, action);
    default:
      return state;
  }
};

export default qcApi;
